var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneTiltRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.415 3.585a2 2 0 00-1.957-.51h-.02l-23.992 7.28a2 2 0 00-.302 3.73l10.702 5.07 5.069 10.702a1.983 1.983 0 001.975 1.136 1.985 1.985 0 001.75-1.439l7.275-23.992v-.02a2 2 0 00-.5-1.957zm-8.686 25.397l-.006.017-4.92-10.386 5.904-5.906a1 1 0 00-1.413-1.414l-5.907 5.905L3 12.278h.018L27 5l-7.271 23.982z"
  })));
}
export default SvgPaperPlaneTiltRegular;